import { render, staticRenderFns } from "./Intelligent.vue?vue&type=template&id=59d20e75&scoped=true"
import script from "./Intelligent.vue?vue&type=script&lang=js"
export * from "./Intelligent.vue?vue&type=script&lang=js"
import style0 from "./Intelligent.vue?vue&type=style&index=0&id=59d20e75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d20e75",
  null
  
)

export default component.exports